import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { CmsComponentConfig, TCustomCmsPageType } from '@interfaces/config';
import { Breadcrumb, TSpsSeo } from '@models/interfaces';

export namespace CmsPageActions {
  export const fetch = createAction('[CMS PAGES] fetch', props<{ url: string }>());

  export const fetchSuccess = createAction(
    '[CMS PAGES] fetchSuccess',
    props<{
      payload: {
        url: string;
        cacheKey: string;
        title: string;
        breadcrumbs: Breadcrumb[];
        newsletterCta: boolean;
        cmsPageType: TCustomCmsPageType;
        componentConfigs: CmsComponentConfig<any>[];
        seo: TSpsSeo;
      };
    }>()
  );

  export const fetchError = createAction('[CMS PAGES] fetchError', props<{ error: string | HttpErrorResponse }>());
}
